var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocBackBlurred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 51,
    viewBox: "0 0 81 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_151_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6779 4.61035V46.4381C80.6779 47.648 80.2313 48.8084 79.4362 49.664C78.6412 50.5195 77.5629 51.0002 76.4386 51.0002H4.23939C3.11503 51.0002 2.03673 50.5195 1.24169 49.664C0.44665 48.8084 0 47.648 0 46.4381V4.61035H80.6779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6779 2.52842V4.61017H0V2.52842C0 1.85784 0.44665 1.21473 1.24169 0.74056C2.03673 0.26639 3.11502 0 4.23938 0H76.4386C77.5629 0 78.6412 0.26639 79.4362 0.74056C80.2313 1.21473 80.6779 1.85784 80.6779 2.52842Z",
    fill: "#6B22B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17623 3.24134e-08H76.8903C77.8941 0.000710032 78.8565 0.33218 79.5665 0.92171C80.2765 1.51124 80.6761 2.3107 80.6777 3.14473L80.6629 3.74576C80.6629 2.00945 78.949 0.59936 76.8425 0.59936H3.47943C2.63808 0.59891 1.82008 0.82919 1.15234 1.25449C1.50477 0.86486 1.96145 0.54869 2.48626 0.33096C3.01108 0.11324 3.58964 -6.99676e-05 4.17623 3.24134e-08Z",
    fill: "#C35CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3896 36.5933H72.0337V38.3221H29.3896V36.5933Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.627 11.2373H72.0338V12.9661H23.627V11.2373Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8813 16.7119H72.0338V18.4407H36.8813V16.7119Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9321 21.8984H72.0338V23.6273H25.9321V21.8984Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07764 21.7949H23.3507V23.5237H5.07764V21.7949Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3389 26.7969H72.0338V28.5257H57.3389V26.7969Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2881 26.7969H53.3051V28.5257H34.2881V26.7969Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18604 26.7969H30.542V28.5257H5.18604V26.7969Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18604 41.4917H30.542V43.2205H5.18604V41.4917Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5591 41.4917H57.915V43.2205H32.5591V41.4917Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.644 41.4917H72.0338V43.2205H59.644V41.4917Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6777 36.5933H25.0675V38.3221H12.6777V36.5933Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07764 16.8398H28.3864V18.5687H5.07764V16.8398Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18652 31.6948H72.034V33.4236H5.18652V31.6948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85938 11.2104H19.957V12.9393H7.85938V11.2104Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_151_201",
    x: -2,
    y: -2,
    width: 84.6777,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_151_201"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocBackBlurred);
export default __webpack_public_path__ + "static/media/doc-back-blurred.4175f733a4a3402ae1de64a63f1be15c.svg";
export { ForwardRef as ReactComponent };